<template>
  <div>
    <base-header class="header pb-8 pt-5 pt-lg-8 d-flex align-items-center">
      <!-- Mask -->
      <span class="mask bg-gradient-warning opacity-8"></span>
      <!-- Header container -->
      <div class="container-fluid d-flex align-items-center">
        <div class="row">
          <div class="col-lg-7 col-md-10">
            <p class="text-white mt-3 mb-5">
              Confira a lista de todas as startups selecionadas para o pitch
              day. Após visualizar as informações da startup, você pode
              preencher a ficha de avaliação e deixar comentários.
            </p>
          </div>
        </div>
      </div>
    </base-header>
    <div class="container-fluid mt--7">
      <div class="row">
        <div class="col">
          <div v-if="!empty" class="card-deck vld-parent" ref="startups_list">
            <div
              class="col-lg-3 col-md-6 mb-5 d-flex align-items-stretch"
              v-for="startup in startups"
              :key="startup.user_id"
            >
              <div class="card text-center flex-grow-1">
                <div class="card-profile-image">
                  <img
                    :src="startup.logo.url"
                    class="card-image my-3"
                    alt="..."
                  />
                </div>
                <div class="card-body mt-7 pt-4 pb-0">
                  <h2 class="card-title text-orange mb-1">
                    {{ startup.name }}
                  </h2>
                  <div>
                    <div class="h5 font-weight-300 mb-1">
                      <i class="ni ni-pin-3 mr-2"></i
                      >{{ startup.city || "..." }}, {{ startup.state || "..." }}
                    </div>
                    <div class="h5 mt-2">
                      <badge type="info">
                        {{ startup.sector }}
                      </badge>
                    </div>
                  </div>
                </div>
                <div class="card-footer text-center">
                  <router-link
                    v-if="isAlreadyEvaluated(startup.subscription_id)"
                    :to="`/investidor/pitch-days/${startup.pitch_day_id}/inscricoes/${startup.subscription_id}/avaliar`"
                    class="text-success"
                    ><i class="fas fa-edit mr-1" title="Avaliação"></i> Já
                    avaliada</router-link
                  >
                  <router-link
                    v-else
                    :to="`/investidor/pitch-days/${startup.pitch_day_id}/inscricoes/${startup.subscription_id}/avaliar`"
                    ><i class="fas fa-edit mr-1" title="Avaliação"></i> Avaliar
                    startup</router-link
                  >
                </div>
              </div>
            </div>
          </div>
          <div v-else class="row">
            <div class="col-12 text-center">
              <badge type="info" class="bg-white">
                Nenhuma startup disponível para avaliação no pitch day no
                momento.
              </badge>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import api from "@/services/api";

export default {
  name: "startups_list",
  data() {
    return {
      startups: [],
      subscriptionsAlreadyEvaluated: [],
      empty: false,
    };
  },
  async mounted() {
    const loader = this.$loading.show({
      container: this.$refs.startups_list,
      width: 150,
      height: 150,
      color: "#ffffff",
      backgroundColor: "transparent",
    });
    this.loadStartups();
    this.loadEvaluations();
    loader.hide();
  },
  methods: {
    async loadStartups() {
      try {
        const { data } = await api.get(
          `/investor-pitch-days/${this.$route.params.id}`
        );
        const defaultLogoPath = "/img/pages/default_logo.png";
        data.forEach((startup) => {
          if (!startup.logo) startup.logo = { url: defaultLogoPath };
        });
        if (data.length) this.startups = data;
        else this.empty = true;
      } catch (e) {
        this.$toasted.error(
          "Ocorreu um erro ao recuperar as startups para a avalação"
        );
        this.$router.push("/investidor/pitch-days");
      }
    },
    async loadEvaluations() {
      try {
        const { data } = await api.get(
          `/investor-pitch-days/${this.$route.params.id}/responses`
        );
        this.subscriptionsAlreadyEvaluated = data.map((e) => e.subscription_id);
      } catch (e) {
        this.$toasted.error("Ocorreu um erro ao recuperar as informações");
      }
    },
    isAlreadyEvaluated(subscriptionId) {
      return this.subscriptionsAlreadyEvaluated.includes(subscriptionId);
    },
  },
};
</script>
<style scoped>
.card-image {
  width: 140px;
  height: 140px;
  border-radius: 10%;
  margin: auto;
}
</style>
